module.exports = __webpack_public_path__ + "img/header-ccc_mobile.8d15807.webp";